import { QueryClient } from '@tanstack/react-query';
import { createBrowserRouter } from 'react-router';

import { LoadingSpinner } from '@/components/ui/spinner';
import {
  ProtectedRoute,
  ProtectedRouteForAdminAndSecretariat,
  ProtectedRouteForAdmin,
} from '@/lib/auth';

import { AppRoot } from './app/root';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createRouter = (queryClient: QueryClient) => {
  console.info('index.tsx_1');

  return createBrowserRouter([
    {
      path: '/:tenantSlug',
      hydrateFallbackElement: <LoadingSpinner />,
      children: [
        {
          path: '',
          lazy: async () => {
            console.info('index.tsx_2');

            const { LandingRoute } = await import('./landing');
            return { Component: LandingRoute };
          },
        },
        {
          path: 'auth',
          children: [
            {
              // /authはログイン画面にリダイレクト
              path: '',
              lazy: async () => {
                console.info('index.tsx_3');

                const { LandingRoute } = await import('./landing');
                return { Component: LandingRoute };
              },
            },
            {
              path: 'login',
              lazy: async () => {
                console.info('index.tsx_4');

                const { LoginRoute } = await import('./auth/login-root');
                return { Component: LoginRoute };
              },
            },
            {
              path: 'mfa',
              lazy: async () => {
                console.info('index.tsx_5');

                const { MfaRoute } = await import('./auth/mfa-root');
                return { Component: MfaRoute };
              },
            },
            {
              path: 'password-reset',
              children: [
                {
                  path: '',
                  lazy: async () => {
                    console.info('index.tsx_6');

                    const { ForgotPasswordRoute } = await import(
                      './auth/password-reset/forgot-password'
                    );
                    return { Component: ForgotPasswordRoute };
                  },
                },
                {
                  path: 'email-sent',
                  lazy: async () => {
                    console.info('index.tsx_7');

                    const { ResetEmailSentRoute } = await import(
                      './auth/password-reset/reset-email-sent'
                    );
                    return { Component: ResetEmailSentRoute };
                  },
                },
                {
                  path: 'reset',
                  lazy: async () => {
                    console.info('index.tsx_8');

                    const { ResetPasswordRoute } = await import(
                      './auth/password-reset/reset'
                    );
                    return { Component: ResetPasswordRoute };
                  },
                },
                {
                  path: 'complete',
                  lazy: async () => {
                    console.info('index.tsx_9');

                    const { ResetCompleteRoute } = await import(
                      './auth/password-reset/complete'
                    );
                    return { Component: ResetCompleteRoute };
                  },
                },
                {
                  path: 'expired',
                  hydrateFallbackElement: <LoadingSpinner />,
                  lazy: async () => {
                    console.info('index.tsx_23');

                    const { ExpiredRoute } = await import(
                      './auth/password-reset/expired'
                    );
                    return { Component: ExpiredRoute };
                  },
                },
              ],
            },
          ],
        },
        {
          path: 'app',
          element: (
            <ProtectedRoute>
              <AppRoot />
            </ProtectedRoute>
          ),
          children: [
            {
              path: 'document',
              children: [
                {
                  path: '',
                  lazy: async () => {
                    console.info('index.tsx_10');

                    const { DocumentListRoute } = await import(
                      './app/document/document'
                    );
                    return { Component: DocumentListRoute };
                  },
                },
                {
                  path: ':documentId',
                  lazy: async () => {
                    console.info('index.tsx_11');

                    const { DocumentDetailRoute } = await import(
                      './app/document/document-detail'
                    );
                    return { Component: DocumentDetailRoute };
                  },
                },
                {
                  path: 'create',
                  element: <ProtectedRouteForAdminAndSecretariat />,
                  children: [
                    {
                      path: '',
                      lazy: async () => {
                        console.info('index.tsx_12');

                        const { CreateDocumentRoute } = await import(
                          './app/document/create/create-document'
                        );
                        return { Component: CreateDocumentRoute };
                      },
                    },
                    {
                      path: 'draft/:documentId',
                      lazy: async () => {
                        console.info('index.tsx_13');

                        const { DraftDocumentRoute } = await import(
                          './app/document/create/draft-document'
                        );
                        return { Component: DraftDocumentRoute };
                      },
                    },
                    {
                      path: 'file',
                      lazy: async () => {
                        console.info('index.tsx_14');

                        const { DocumentFileUploadRoute } = await import(
                          './app/document/create/document-file-upload'
                        );
                        return { Component: DocumentFileUploadRoute };
                      },
                    },
                    {
                      path: 'attribute',
                      lazy: async () => {
                        console.info('index.tsx_15');

                        const { DocumentAttributeRoute } = await import(
                          './app/document/create/document-attribute'
                        );
                        return { Component: DocumentAttributeRoute };
                      },
                    },
                    {
                      path: 'signer',
                      lazy: async () => {
                        console.info('index.tsx_16');

                        const { SignerSettingRoute } = await import(
                          './app/document/create/signer-setting'
                        );
                        return { Component: SignerSettingRoute };
                      },
                    },
                    {
                      path: 'position',
                      lazy: async () => {
                        console.info('index.tsx_17');

                        const { SignPositionRoute } = await import(
                          './app/document/create/sign-position'
                        );
                        return { Component: SignPositionRoute };
                      },
                    },
                    {
                      path: 'confirm',
                      lazy: async () => {
                        console.info('index.tsx_18');

                        const { DocumentConfirmRoute } = await import(
                          './app/document/create/document-confirm'
                        );
                        return { Component: DocumentConfirmRoute };
                      },
                    },
                  ],
                },
              ],
            },
            {
              path: 'tenant',
              element: <ProtectedRouteForAdmin />,
              children: [
                {
                  path: '',
                  lazy: async () => {
                    console.info('index.tsx_19');

                    const { TenantPageRoute } = await import(
                      './app/tenant/tenant-page'
                    );
                    return { Component: TenantPageRoute };
                  },
                },
              ],
            },
            {
              path: 'user',
              element: <ProtectedRouteForAdminAndSecretariat />,
              children: [
                {
                  path: '',
                  lazy: async () => {
                    console.info('index.tsx_20');

                    const { UserListRoute } = await import('./user/user');
                    return { Component: UserListRoute };
                  },
                },
              ],
            },
            {
              path: 'not-found',
              lazy: async () => {
                console.info('index.tsx_21');

                const { AppNotFoundRoute } = await import('./app/not-found');
                return { Component: AppNotFoundRoute };
              },
            },
            {
              path: '*',
              lazy: async () => {
                console.info('index.tsx_22');

                const { AppNotFoundRoute } = await import('./app/not-found');
                return { Component: AppNotFoundRoute };
              },
            },
          ],
        },
      ],
    },
    {
      path: '*',
      hydrateFallbackElement: <LoadingSpinner />,
      lazy: async () => {
        console.info('index.tsx_24');

        const { NotFoundRoute } = await import('./not-found');
        return { Component: NotFoundRoute };
      },
    },
  ]);
};
